import { Box, Flex, Grid, Paper, Text, Title } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { CheckedIcon, EditIcon } from "../../shared/svg";
import "./Profile.scss";
import useProfileStore from "../../store/useProfileStore";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

export const Goals = () => {
  const laptop = useMediaQuery("(max-width: 1100px)");
  const { profile } = useProfileStore();
  const goals = profile?.goals || [];
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Paper withBorder radius="24px" p={32} h="100%" pos="relative">
      <div
        className="edit-icon"
        onClick={() => navigate("/profile/edit/goals")}
      >
        <EditIcon />
      </div>
      <Title size={36} lh="50px">
        {t("goals")}
      </Title>
      <Grid mt={40} gutter={40}>
        {goals.length > 0 ? (
          goals.map((goal, index) => {
            const { title, answers, text_answer } = goal;
            const hasAnswers = answers.length > 0;

            return (
              <Grid.Col span={laptop ? 12 : 6} key={index}>
                <Text fw="bold">{title}</Text>

                {hasAnswers &&
                  !text_answer &&
                  answers.map((answer) => (
                    <Flex mt={8} gap={8} key={answer.id}>
                      <CheckedIcon />
                      <Text>{answer.text}</Text>
                    </Flex>
                  ))}

                {text_answer && (
                  <Flex mt={hasAnswers ? 12 : 8} gap={8}>
                    <Box
                      w={20}
                      h={20}
                      mt={2}
                      style={{ svg: { flexShrink: 0 } }}
                    >
                      <CheckedIcon />
                    </Box>
                    <Text
                      style={{ wordBreak: "break-word", whiteSpace: "wrap" }}
                    >
                      {text_answer}
                    </Text>
                  </Flex>
                )}
              </Grid.Col>
            );
          })
        ) : (
          <Text p="0 0 24px 24px" c="#737373">
            {t("no_goals")}
          </Text>
        )}
      </Grid>
    </Paper>
  );
};
